import React, {useState} from "react";
import TextField from "@mui/material/TextField";
import {Button} from "@mui/material";
import {Trans} from "../../utils/i18n";
import {Alert} from "@material-ui/lab";
import classNames from "classnames";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MuiCheckbox from "@material-ui/core/Checkbox";
import Markdown from "react-markdown";

export default function SingleQuestion({ answers, question, form,  }) {
    const value = answers[question.id] || null;
    const [textInput, setTextInput] = useState(value);
    const selectedAnswer = question.answers.find((answer) => {
        if(answer.regex) {
            const strippedRegex = answer.regex ? answer.regex.replace(/^\/|\/$/g, '') : null;
            const regexValid = strippedRegex ? (new RegExp(strippedRegex)) : null;
            return regexValid.test(value);
        }
        return answer.title === value;
    });
    const [textInputValid, setTextInputValid] = useState(selectedAnswer?.regex ? true : null);

    return (
        <div>
            {
                question.description && (
                    <Markdown
                        components={{
                            a: ({ node, ...props }) => (
                                <a {...props} target="_blank" rel="noopener noreferrer" />
                            ),
                        }}
                    >
                        {question.description}
                    </Markdown>
                )
            }
            <div className={"grid grid-cols-3 gap-6"}>
                {
                    question.answers.map((answer, index) => {
                        if(answer.regex) {
                            const checkRegex = () => {
                                if(textInputValid === true) {
                                    setTextInputValid(null);
                                    setTextInput(null);
                                    form.change(`workflow_questions[${question.id}]`, null);
                                    return;
                                }
                                const strippedRegex = answer.regex ? answer.regex.replace(/^\/|\/$/g, '') : null;
                                const regexValid = strippedRegex ? (new RegExp(strippedRegex)) : null;
                                setTextInputValid(regexValid.test(textInput));
                                if(regexValid.test(textInput)) {
                                    form.change(`workflow_questions[${question.id}]`, textInput);
                                    form.change("workflow_questions_valid", false);
                                    if(answer.nextQuestion) {
                                        form.change(`workflow_questions[${answer.nextQuestion.id}]`, null);
                                    }
                                }
                            };
                            return (
                                <div className={"col-span-3 flex flex-wrap  gap-3"}>
                                    <div className={"flex-1"}>
                                        <TextField
                                            label={answer.title}
                                            disabled={textInputValid}
                                            value={textInput || ""}
                                            onChange={(e) => setTextInput(e.target.value)}
                                            onKeyDown={(e) => {
                                                if(e.key === "Enter") {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    checkRegex();
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className={""}>
                                        <Button
                                            variant="contained"
                                            color={"secondary"}
                                            onClick={checkRegex}
                                        >
                                            {
                                                textInputValid === true ? (
                                                        <Trans i18nKey={"common.edit"}>Edit</Trans>
                                                    ):
                                                    (
                                                        <Trans i18nKey={"common.check"}>Check</Trans>
                                                    )
                                            }
                                        </Button>
                                    </div>
                                    <div className={"w-full"}>
                                        {
                                            textInputValid === false && (
                                                <Alert severity="error">
                                                    The provided serial number could not be found. Please make sure that you are using the charger provided by Segway-Ninebot.
                                                </Alert>
                                            )
                                        }
                                    </div>
                                </div>
                            )
                        }

                        if(question.answers.length === 1) {
                            return (
                                <FormControlLabel
                                    id={"answer.title"}
                                    control={
                                        <MuiCheckbox
                                            // checked={state.checkedB}
                                            // onChange={handleChange}
                                            color="primary"
                                            // error={touched && error}
                                            checked={!!value}
                                            onChange={(event) => {
                                                if(!event.target.checked) {
                                                    form.change(`workflow_questions[${question.id}]`, null);
                                                    form.change("workflow_questions_valid", false);
                                                    return;
                                                }
                                                form.change(`workflow_questions[${question.id}]`, answer.title);
                                                if (!answer.nextQuestion && answer.action === "end_flow") {
                                                    form.change("workflow_questions_valid", false);
                                                } else if (!answer.nextQuestion) {
                                                    form.change("workflow_questions_valid", true);
                                                    if (answer.result_image) {
                                                        form.change("workflow_questions_display_image", answer.result_image);
                                                        form.change("workflow_questions_display_markdown", answer.result_markdown);
                                                    } else {
                                                        form.change("workflow_questions_display_image", null);
                                                    }
                                                } else {
                                                    form.change("workflow_questions_valid", false);
                                                    form.change(`workflow_questions[${answer.nextQuestion.id}]`, null);
                                                }
                                            }}
                                        />
                                    }
                                    label={answer.title}
                                />
                            );
                        }

                        return (
                            <div
                                key={index}
                                className={classNames(
                                    'w-full h-full p-2.5 inline-flex flex-col justify-end font-normal text-base mb-2.5 cursor-pointer relative transition-all duration-200 ease-in-out rounded-lg text-center ',
                                    {
                                        //'shadow-[0_1px_4px_2px_rgb(255,0,0)]': error,
                                        'bg-white shadow-[0_1px_8px_rgba(0,0,0,0.15)]': value !== answer?.title,
                                        'bg-[#F4F9FF] shadow-[0_1px_4px_2px_rgba(42,91,151,0.7)]': value === answer?.title
                                    }
                                )}
                                // className={classNames({
                                //     "rounded-2xl border-2 p-9 font-bold text-2xl": true,
                                //     "border-gray-100": selectedAnswer?.title !== answer?.title,
                                //     "shadow-2xl border-2": selectedAnswer?.title === answer?.title,
                                // })
                                onClick={() => {
                                    if (answer.action?.includes("set_request_type_")) {
                                        const requestType = answer.action.replace("set_request_type_", "");
                                        form.change("requesttype", requestType);
                                    }
                                    form.change(`workflow_questions[${question.id}]`, answer.title);
                                    if (!answer.nextQuestion && answer.action === "end_flow") {
                                        form.change("workflow_questions_valid", false);
                                    } else if (!answer.nextQuestion) {
                                        form.change("workflow_questions_valid", true);
                                        if (answer.result_image) {
                                            form.change("workflow_questions_display_image", answer.result_image);
                                            form.change("workflow_questions_display_markdown", answer.result_markdown);
                                        } else {
                                            form.change("workflow_questions_display_image", null);
                                        }
                                    } else {
                                        form.change("workflow_questions_valid", false);
                                        form.change(`workflow_questions[${answer.nextQuestion.id}]`, null);
                                    }
                                }}
                            >
                                <span className={"font-bold my-3"}>
                                    {
                                        answer.title
                                    }
                                </span>
                                {
                                    answer.description && <span className={"font-light my-1"}>
                                        {
                                            answer.description
                                        }
                                    </span>
                                }
                            </div>
                        );
                    })
                }
            </div>
            {
                selectedAnswer?.result_text && (
                    <div className={"mt-12"}>
                        <Alert severity="info">
                            {selectedAnswer?.result_text}
                        </Alert>
                    </div>
                )
            }
            {
                selectedAnswer?.nextQuestion && (
                    <SingleQuestion  answers={answers} form={form} question={selectedAnswer.nextQuestion}/>
                )
            }
        </div>
    );
}
